import awsdk from 'awsdk';

// APPOINTMENT
// REFERRAL
// SICKSLIP

export const PostVisitFollowUpItemType = awsdk.AWSDKPostVisitFollowUpItemType;
export type PostVisitFollowUpItemType = typeof PostVisitFollowUpItemType;
